import type { Paramsv1WxopenCustomerDetailGet } from '@api/mk-material-center/services/api/WxminiCustomerApi';
import WxminiCustomerApi from '@api/mk-material-center/services/api/WxminiCustomerApi';
import type { Paramsv1TagCusRuleGet } from '@api/mk-tag-svc/services/api/RuleApi';
import RuleApi from '@api/mk-tag-svc/services/api/RuleApi';
import type { ParamswxpublicGetUserInfoGet } from '@api/wxopen/services/api/WeixinAuthApi';
import WeixinAuthApi from '@api/wxopen/services/api/WeixinAuthApi';
import IsThreePartAppApi from '@/api/wxopen/services/api/IsThreePartAppApi';
import EnterpriseInfoApi from '@/api/mk-account-svc/services/api/EnterpriseInfoApi';
import { SaleShareRecordPost } from '@/h5/reportApi';
import { isBindMiniProgram } from '@cfx/iutils';
import { webGateway } from '@ajax';

// 获取规则详情
export const reqRulesInfo = async (params: Paramsv1TagCusRuleGet) => {
  const res: any = await RuleApi.v1TagCusRuleGet(params);
  if (res.code === 500200 && res.success) return res.data.rules || [];

  throw res;
};

/**
 * 小程序访问素材时，判断是否绑定手机号
 */
export const reqGetPhone = async (params: Paramsv1WxopenCustomerDetailGet) => {
  const res: any = await WxminiCustomerApi.v1WxopenCustomerDetailGet(params);
  if (res.success && res.code === 500200) {
    return {
      isBindPhone: res.data.exist,
      mobile: res.data.mobiles || []
    };
  }
  throw res;
};

// 获取用户信息
export const reqGetUserInfo = async (params: ParamswxpublicGetUserInfoGet) => {
  const res = await WeixinAuthApi.wxpublicGetUserInfoGet(params);
  return res;
};

// 上报
export const reqSaleShareRecordPost = async (params: any) => {
  const res = await SaleShareRecordPost(params);
  return res;
};

// 获取绑定小程序信息，用于判断是否绑定小程序
export const getBindMiniAppId = async () => {
  const { isBind = false, appId } = await isBindMiniProgram({
    webGateway,
    service: { data: { subDomain: 'bizWxCardMini' }, extra: {} }
  });
  return isBind ? appId : '';
};

// 查询租户企微应用是否是三方应用
export const getQwIsThirdPartyApp = async (companyId = '') => {
  const params = { companyId };
  const { success, data }: any = await IsThreePartAppApi.qwIsThirdPartyAppGet(params);
  if (success) return data;

  throw data;
};

// 获取企业信息
export const getCompanyInfo = async (corpId: string) => {
  const { success, data } = await EnterpriseInfoApi.v1EnterpriseInfoGet({ corpId });
  if (success) return data;

  throw data;
};
